import { ptBr } from '../i18n/pt_br'
import { enUs } from '../i18n/en_us'
import i18n from 'live/services/i18n'

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'pt_br'
const localeFiles = { pt_br: ptBr, en_us: enUs }

export function addi18n(): void {
    i18n.add(localeFiles[locale])
}